import { ApplicationConfig, inject } from '@angular/core';
import { PreloadAllModules, provideRouter, RouteReuseStrategy, withComponentInputBinding, withDebugTracing, withPreloading, withRouterConfig } from '@angular/router';
import { routes } from './app.routes';
import { provideResolverLoader } from '@providers/resolver-loader.provider';
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { authInterceptor } from './interceptors/auth.interceptor';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { iosTransitionAnimation, mdTransitionAnimation } from '@ionic/angular';
import { noopTransition } from '@constants/app.transition';
import { computePlatformFromWindow } from '@services/platform-info.service';
import { provideTranslateService } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";
import { provideCustomIcons } from '@providers/custom-icons.provider';
import { loaderInterceptor } from './interceptors/loader.interceptor';


export const appConfig: ApplicationConfig = {
	providers: [
		{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
		provideIonicAngular({
			navAnimation: (baseEl, opts) => {
				const win = baseEl.ownerDocument!.defaultView!;
				const info = computePlatformFromWindow(win);

				if (info.token.startsWith('web:') && info.token.includes(':desktop:')) {
					return noopTransition(baseEl, opts);
				}

				// fallback alla transizione nativa della piattaforma
				const isIOS = /iPad|iPhone|iPod/.test(win.navigator.userAgent);
				return isIOS ? iosTransitionAnimation(baseEl, opts) : mdTransitionAnimation(baseEl, opts);
			},
			rippleEffect: false
		}),
		provideCustomIcons(),
		provideRouter(routes, withPreloading(PreloadAllModules), withComponentInputBinding(), withRouterConfig({ onSameUrlNavigation: 'reload' })),
		provideHttpClient(
			withInterceptors([
				authInterceptor,
				loaderInterceptor
			]),
		),
		provideTranslateService({
			loader: provideTranslateHttpLoader({
				prefix: '/assets/i18n/',
				suffix: '.json'
			})
		}),
		provideResolverLoader({
			match: url => url !== '/' && !/^\/(auth)(\/|$)/.test(url),
			message: 'Sto recuperando i dati...',
			delayMs: 120,
			minDurationMs: 300,
			includeLazyLoad: true,
			loading: {
				cssClass: 'app-resolver-loader',
				showBackdrop: true,
				translucent: true,
			}
		})
	],
};